// Imported statically, not lazy loaded: a missing chunk after a deployment reloads the page at once
// (reloadOnMissingChunk), which could lose a composition not saved yet. See
// docs/ingredient-suggestion.md
import modelJson from "./ingredientSuggestionModel.json";
import {
  indexSuggestionModel,
  parseSuggestionModel,
  type SuggestionIndex,
} from "./ingredientSuggestion";

export * from "./ingredientSuggestion";

let suggestionIndex: SuggestionIndex | null = null;

export function getIngredientSuggestionIndex(): SuggestionIndex {
  suggestionIndex ??= indexSuggestionModel(parseSuggestionModel(modelJson));
  return suggestionIndex;
}
